export const modalToSelectFavoriteCompany = {
    titleWithTheme: '「{{theme}}」におけるお気に入り企業一覧',
    title: 'お気に入り企業一覧',
    tableHeader1: '企業名'
}
